import React from 'react';
import { render } from '@testing-library/react';
import Background from './Background';

test('background has svg', () => {
    // @ts-ignore
    const { container } = render(<Background />);
    // eslint-disable-next-line testing-library/no-container, testing-library/no-node-access
    const svgComponent = container.querySelector('svg');
    expect(svgComponent).not.toBeNull();
});
